export class ManagerConfig {
    apiUrl = "";
    flags: { [key: string]: boolean } = {};
}
